import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
// import { Input as ReactInput, Label } from "@vzrf/react-forms";
import { Input } from "@vds/inputs";
import { TitleLockup } from "@vds/type-lockups";
import { Feature,Body,Title } from "@vds/typography"

import { setA11yContent } from "../NavigationHelper/actions";
import { verifyFormerCustomer } from "./actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { clearErrors } from "../DownloadAndDelete/actions";
import { media,isMobile } from "utils/style";

import GoBack from "common-components/GoBack";
import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";
import Loader from "common-components/RectangleLoader";
import Alert from "common-components/Alert";

import FetchPageContent from "../../../hoc/FetchPageContent";

import { OnlyActiveAccounts, ActiveAndInactiveAccounts } from "./modals";
import Warning from "../../../../assets/svgs/Warning.svg";
import SuccessInputImg from "../../../../assets/svgs/SuccessInputImg.svg";

class VerifyFormerCustomer extends Component {
  state = {
    pinLength: 0,
    firstName: "",
    lastName: "",
    modalToDisplay: "",
    guestFlowUrl: "",
    ssnValidation: false,
    error: ""
  };
  InputRef= React.createRef();

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("verify customer", this.props.pageContent.sc_pagetitle);
    }
  }

  handleKeyPress = e => {
    const charCode = e.which ? e.which : e.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  resetInputValue = () => {
    this.InputRef.current.value = ""; //getElementById("customerSSN")
  };

  updatePinLength = () => {
    this.setState({ pinLength: this.InputRef.current.value.length }, () => {  //getElementById("customerSSN")
      if (this.state.pinLength && this.state.pinLength >= 1) {
        this.setState({
          ssnValidation: false,
          error: ""
        })
      }
    });
    if (this.props.error) {
      this.props.clearErrors();
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const inputVal = this.InputRef.current.value;   //getElementById("customerSSN")
    
    const { firstName, lastName } = this.state;
    const flow = this.props.location && this.props.location.state && this.props.location.state.flow ? this.props.location.state.flow : "";
    let currentIntent;
    if (this.props.location.state && this.props.location.state.currentIntent) {
      currentIntent = this.props.location.state.currentIntent
    } else if (this.props.location.state && this.props.location.state.flow && this.props.location.state.flow === "correction") {
      currentIntent = "correct"
    } else {
      currentIntent = null
    }
    const serviceType = this.props.location.state && this.props.location.state.serviceType ? this.props.location.state.serviceType : null;
    const isOptOutSelection = this.props.location.state && this.props.location.state.isOptOut ? this.props.location.state.isOptOut : null;
    this.props.verifyFormerCustomer(firstName, lastName, inputVal, window.uniqId, flow).then(() => {
      this.resetInputValue();
      this.setState({ pinLength: 0 });
      if (!this.props.error) {
        //IF THE FLOW IS FOR CORRECTION,
        //SEND THEM TO SUBMIT CORRECTION REQUEST PAGE DIRECTLY, AND LAUNCH IG PAGE.
        const { formerCustomerAccountInfo, formerId } = this.props;
        // IF CUSTOMER HAS ACTIVE AND INACTIVE ACCOUNTS
        // SHOW MODAL - CONTINUE FORMER CUSTOMER FLOW
        // ---------
        // IF CUSTOMER ONLY HAS ACTIVE ACCOUNTS
        // SHOW MODAL - SEND TO LOGIN PAGE
        // ---------
        // ELSE
        // CONTINUE THE FLOW
        
        if (formerCustomerAccountInfo && formerCustomerAccountInfo.length) {
          let activeAccountCount = 0;
          for (let item of formerCustomerAccountInfo) {
            if (item.status && item.status.toLowerCase() === "l") {
              activeAccountCount++;
            }
          }
          // Checking the item.status === "f" flag here and IG migration flag also
          let inActiveAccountCount = 0;
          if (activeAccountCount === 0) {
            for (let item of formerCustomerAccountInfo) {
              if (item.status && item.status.toLowerCase() === "f") {
                inActiveAccountCount++;
              }
            }
          }

          // changes made to work for IG Migration as well  
          if (activeAccountCount === formerCustomerAccountInfo.length) {
            this.setState({ modalToDisplay: "onlyActiveAccounts" });
          } else if (inActiveAccountCount === formerCustomerAccountInfo.length) {
            var data = {
              fname: this.state.firstName,
              lname: this.state.lastName,
              currentIntent: currentIntent,
              isOptOutChoice: isOptOutSelection,
              serviceType: serviceType,
              formerUuid: true
            }
            this.props.history.replace({
              pathname: "email-info",
              state: { data }
            });
          } else {
            this.setState({ modalToDisplay: "activeAndInactiveAccounts" });
          }
        }
      }
    });
  };

  updateName = ({ target: { value, name } }) => {
    this.setState({ [name]: value.replace(/[^\w\s/@#$%^&\-\*():;"?_|.,+=!|\\]/gi, "") })
  };

  renderModal = modalContent => {
    const { modalToDisplay } = this.state;

    if (!modalToDisplay) {
      return null;
    }

    if (modalToDisplay === "onlyActiveAccounts") {
      return (
        <OnlyActiveAccounts
          modalContent={modalContent.only_active_accounts_modal}
          closeModal={this.closeModal}
        />
      );
    } else {
      return (
        <ActiveAndInactiveAccounts
          modalContent={modalContent.active_and_inactive_accounts_modal}
          guestFlowUrl={this.state.guestFlowUrl}
          continueCloseModal={this.continueCloseModal}
          closeModal={this.closeModal}
        />
      );
    }
  };

  closeModal = () => {
    this.setState({ modalToDisplay: "" });
  };

  continueCloseModal = () => {
    this.setState({ modalToDisplay: "" });
    var data = {
      fname: this.state.firstName,
      lname: this.state.lastName,
      currentIntent: this.props.location.state.currentIntent ? this.props.location.state.currentIntent : "",
      serviceType: this.props.location.state.serviceType ? this.props.location.state.serviceType : "",
      isOptOutChoice: this.props.location.state.isOptOut ? this.props.location.state.isOptOut : "",
      formerUuid: true
    }
    this.props.history.replace({
      pathname: "/privacy/your-data/former-customer/email-info",
      state: { data }
    });
  };

  handleKeyPressWhiteSpace = e => {
    const charCode = e.which ? e.which : e.keyCode;
    var name = e.target.name
    if ((charCode == 32 && this.state[name] <= 0) ||
      (e.charCode >= 48 && e.charCode <= 57 && this.state[name] <= 0)) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  render() {
    const { pageContent } = this.props;

    if (!pageContent) {
      return <Redirect to="/privacy/your-data/former-customer" />;
    }

    const {
      genericList: [{ list: inputList }],
      richText: [{ description: errorText }]
    } = pageContent;

    const modalContent = {
      only_active_accounts_modal: this.props.only_active_accounts_modal,
      active_and_inactive_accounts_modal: this.props.active_and_inactive_accounts_modal
    };

    return (
      <Fragment>
        <Container id={"headerContainer"} onMouseMove={(ev) => {
          if (this.state.pinLength && this.state.pinLength == 9) {
            this.setState({
              ssnValidation: true,
              error: ""
            })
          } else if (this.state.pinLength && this.state.pinLength !== 9) {
            this.setState({
              error: "Invalid Social Security number"
            })
          }
        }}>
          {this.renderModal(modalContent)}
          {this.props.loading ? (
            <Loader id="formerLoader" />
          ) : (
            <Fragment>
              <TitleLockup
                  viewport={isMobile ? "mobile": "desktop"}
                  data={{
                  title: {
                    size: 'titleXLarge',
                    bold: false,
                    // primitive: 'h1',
                    children: pageContent.section_title
                  },
                  subtitle : {
                    size: 'titleMedium',
                    primitive: 'p',
                    children: <Body size="large">{convertStringToElements(pageContent.section_description)}</Body>
                  }                  
                  }}
              />
              {/* <Header style={{ maxWidth: "632px", fontFamily: "Verizon NHG DS" }}>{pageContent.section_title}</Header>
              <Div>{convertStringToElements(pageContent.section_description)}</Div> */}

              <form onSubmit={this.handleSubmit}>
                <div style={{ display: "flex", flexWrap: "wrap", maxWidth: "560px" }}>
                  {inputList &&
                    inputList.length &&
                    inputList.map(({ jsonKey, jsonValue, fieldType }) => (
                      <Fragment key={jsonValue}>
                        <InputContainer>
                          {/* <Label
                            htmlFor={jsonValue}
                            style={{ color: "#000000", fontFamily: "Verizon-NHG-eTX", height: "16px", fontSize: "12px", lineHeight: "16px" }}
                          >
                            {jsonKey}
                          </Label> */}
                          {jsonValue === "customerSSN" ? (
                            <Input
                              name="pin"
                              label={jsonKey}
                              type="password"
                              ref={this.InputRef}
                              // className={this.props.error || this.state.error ? "icon" : this.state.ssnValidation ? "successicon" : ""}
                              id={jsonValue}
                              data-qm-block="true"
                              readOnly={false}
                              required={true}
                              disabaled={false}
                              error={this.state.pinLength && this.state.pinLength !==9 ? true :  false}
                              errorText={this.state.pinLength && this.state.pinLength !==9 ? "Invalid Social Security number":""}
                              success={this.state.ssnValidation }
                              data-testId={jsonValue}
                              maxLength="9"
                              autoComplete="off"
                              aria-describedby={`${jsonValue}_error`}
                              onKeyPress={this.handleKeyPress}
                              onChange={this.updatePinLength}
                              // onBlur={() => {
                              //   if (this.state.pinLength && this.state.pinLength == 9) {
                              //     this.setState({
                              //       ssnValidation: true,
                              //       error: ""
                              //     })
                              //   } else if (this.state.pinLength && this.state.pinLength !== 9) {
                              //     this.setState({
                              //       error: "Invalid Social Security number"
                              //     })
                              //   }
                              // }}
                            />
                          ) : (
                            <Input
                              type="text"
                              label={jsonKey}
                              // className={this.props.error && this.state[jsonValue] === "" ? "icon" : ""}
                              error={false}
                              // errorText={fieldType}
                              required={true}
                              readOnly={false}
                              disabaled={false}
                              // helperText={fieldType}
                              helperTextPlacement="bottom"
                              id={jsonValue}
                              name={jsonValue}
                              data-qm-encrypt="true"
                              data-testId={jsonValue}
                              value={this.state[jsonValue]}
                              maxLength="50"
                              onChange={this.updateName}
                              onKeyPress={this.handleKeyPressWhiteSpace}
                            />
                          )}

                          {/* {jsonValue !== "customerSSN" && fieldType && fieldType.length > 0 ?
                            (
                              <Label
                                htmlFor={jsonValue}
                                style={
                                  {
                                    color: "#6F7171",
                                    fontFamily: "Verizon-NHG-eTX",
                                    height: "16px",
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                    marginTop: "8px"
                                  }
                                }>
                                {fieldType}
                              </Label>
                            ) : ""} */}

                          {/* {this.state.error && jsonValue === "customerSSN" && (
                            <ErrorMsg role="alert" id={`${jsonValue}_error`}>
                              {this.state.error}
                            </ErrorMsg>
                          )} */}
                        </InputContainer>
                      </Fragment>
                    ))}
                </div>

                {/* {this.props.error && (
                  <ErrorMsg role="alert">
                    {this.props.error}
                  </ErrorMsg>
                )} */}

                <Button
                  type="submit"
                  disabled={!this.state.firstName || !this.state.lastName || this.state.pinLength < 9}
                  style={{ marginTop: "48px" }}
                  background={pageContent.buttons[0].type}
                >
                  {pageContent.buttons[0].text}
                </Button>
              </form>
            </Fragment>
          )}
        </Container>
        {this.props.error ? (
          <Alert alertType="error" disableAnimation afterCloseRequest={this.props.clearErrors}>
            {errorText}
          </Alert>
        ) : null}
      </Fragment>
    );
  }
}

VerifyFormerCustomer.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object
};

const mapStateToProps = ({
  pageContent: {
    verify_former_customer_form: pageContent,
    only_active_accounts_modal,
    active_and_inactive_accounts_modal
  },
  loadingAndErrorState: { loading, error },
  formerCustomer: { accountInfo: formerCustomerAccountInfo, formerId }
}) => ({
  pageContent,
  loading,
  error,
  formerCustomerAccountInfo,
  only_active_accounts_modal,
  active_and_inactive_accounts_modal,
  formerId
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, verifyFormerCustomer, clearErrors }
  ),
  FetchPageContent
)(VerifyFormerCustomer);

const Div = styled.div`
  max-width: 640px;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
`;

// const Input = styled(ReactInput)`
//   width: 90%;
//   border: 1px solid #6F7171;
//   border-radius: 4px;
//   ${media.mobile`
//     width: 100%;
//   `}
// `;

const InputContainer = styled.div`
  flex: 50%;
  margin-top: 32px;
  width: 100%;
  position: relative;
  box-sizing: border-box;
  padding-right: 15px;
  
  #customerSSN {
    width:50% ;

    ${media.mobile`
    width: 100%;
  `}
  }

  div {
    display: flex;
    align-items:flex-start;
  }
  
  ${media.mobile`
    flex: 100%;
  `}
`;



const Header = styled.h1`
  max-width: 632px;
  font-size: 48px;
  font-family: Verizon NHG DS;
  line-height: 48px;
  margin-bottom: 32px;
  font-weight: 300;

  ${media.mobile`
    max-width: 328px;
    font-size: 32px;
    line-height: 36px;
  `}
`;
const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: "0";
  padding: 48px 16px ;
  `}
`;